document.addEventListener( 'DOMContentLoaded', () => {
	const container = document.querySelector( '.case-study-slider-wrapper' );
	if ( ! container ) {
		return; // Exit if component doesn't exist on page
	}
	
	const stickyContainer = container.querySelector( '.sticky-container' );
	const slider = container.querySelector( '.case-study-slider' );
	
	if ( ! slider ) {
		return; // Exit if slider doesn't exist
	}

	const setContainerHeight = () => {
		// Use the browser's natural scrollWidth calculation
		const totalScrollableWidth = slider.scrollWidth - slider.clientWidth;
		
		// Add a generous buffer to ensure the last slide is fully visible
		const buffer = 200;
		const requiredHeight = totalScrollableWidth + window.innerHeight + buffer;
		container.style.height = `${ requiredHeight }px`;
	};

	const handleScroll = () => {
		const rect = container.getBoundingClientRect();
		const totalScrollableWidth = slider.scrollWidth - slider.clientWidth;
		const totalScrollHeight = container.offsetHeight - window.innerHeight;

		if ( rect.top <= 0 && Math.abs( rect.top ) <= totalScrollHeight ) {
			// Calculate scroll progress (0 to 1)
			let scrollProgress = Math.abs( rect.top ) / totalScrollHeight;
			scrollProgress = Math.max( 0, Math.min( 1, scrollProgress ) );
			
			// Use pixel-based transform with the natural scroll width
			const scrollLeft = scrollProgress * totalScrollableWidth;
			slider.style.transform = `translateX(-${ scrollLeft }px)`;
		} else if ( rect.top > 0 ) {
			slider.style.transform = 'translateX(0px)';
		} else if ( Math.abs( rect.top ) > totalScrollHeight ) {
			slider.style.transform = `translateX(-${ totalScrollableWidth }px)`;
		}
	};

	// Resize + Scroll Handlers
	window.addEventListener( 'resize', () => {
		setContainerHeight();
		handleScroll();
	} );

	window.addEventListener( 'scroll', handleScroll );

	// Initial run
	setContainerHeight();
	handleScroll();
} ); 